import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SessionTypes } from '@walletconnect/types'
import { AddressString } from 'types/index'

import { StateWalletConnectClient } from './types'

const initialState: StateWalletConnectClient = {
  sessions: undefined,
}

export const sliceWalletConnectClient = createSlice({
  initialState,
  name: 'walletConnectClient',
  reducers: {
    addSession: (state, { payload }: PayloadAction<{ poolAddress: AddressString; session: SessionTypes.Struct }>) => {
      const { poolAddress, session } = payload
      if (!state.sessions) state.sessions = {}
      const existing = state.sessions[poolAddress] ?? []
      const withoutDuplicate = existing.filter((s) => s.topic !== session.topic)
      state.sessions[poolAddress] = [...withoutDuplicate, session]
    },
    clearSessions: (state, { payload }: PayloadAction<{ poolAddress: AddressString }>) => {
      if (!state.sessions) return
      state.sessions[payload.poolAddress] = []
    },
    removeSession: (state, { payload }: PayloadAction<{ poolAddress: AddressString; topic: string }>) => {
      const { poolAddress, topic } = payload
      if (!state.sessions?.[poolAddress]) return
      state.sessions[poolAddress] = state.sessions[poolAddress].filter((s) => s.topic !== topic)
    },
  },
})

export const { addSession, clearSessions, removeSession } = sliceWalletConnectClient.actions
